"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.LinkContent = exports.CopyLinkButton = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div')({
  display: 'block'
});
const CopyLinkButton = exports.CopyLinkButton = (0, _mui.styled)(_components.SplitButton, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['fullWidth', 'backgroundGradientColors'])
})(({
  fullWidth,
  theme,
  backgroundGradientColors
}) => ({
  ...(fullWidth ? {
    display: 'flex'
  } : {}),
  height: '45px',
  button: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '1.4rem'
  },
  [`.${_components.splitButtonClasses.disabled}`]: {
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.common.white
  },
  [`& .${_components.splitButtonClasses.content}`]: {
    padding: theme.spacing(0, 3),
    position: 'relative',
    overflow: 'hidden',
    height: '100%',
    ...(fullWidth ? {
      width: '100%'
    } : {}),
    '&::after': {
      background: `linear-gradient(90deg, ${backgroundGradientColors?.color1 ?? (0, _mui.alpha)(theme.palette.common.white, 0.4)} 5.56%, ${backgroundGradientColors?.color2 ?? (0, _mui.alpha)(theme.palette.common.white, 0.6)} 35.02%, ${backgroundGradientColors?.color3 ?? theme.palette.common.white} 112.13%)`,
      content: '""',
      display: 'block',
      height: '100%',
      pointerEvents: 'none',
      position: 'absolute',
      right: 0,
      width: 90
    }
  },
  [`& .${_components.splitButtonClasses.button}`]: {
    padding: theme.spacing(0, 4, 0, 3),
    whiteSpace: 'nowrap',
    width: 125
  }
}));
const LinkContent = exports.LinkContent = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.primary,
  display: 'flex',
  flex: '0 1 auto',
  fontWeight: theme.typography.fontWeightBold,
  minWidth: 200,
  overflow: 'hidden',
  position: 'relative',
  whiteSpace: 'nowrap',
  width: '100%'
}));
//# sourceMappingURL=styles.js.map